var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dropdown',{staticClass:"range-dropdown filter-dropdown",scopedSlots:_vm._u([{key:"btn",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.label))])]},proxy:true},{key:"body",fn:function(){return [_c('range-list',{attrs:{"items":_vm.items},on:{"select":function($event){return _vm.$emit('select', $event)}}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }